var _defs, _path, _path2, _path3, _path4, _circle, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnoff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_16",
    "data-name": "Layer 16",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4d4d4d;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.38,10.99c.24-.14.32-.44.19-.68-.14-.24-.44-.33-.68-.19-1.55.88-2.51,2.53-2.51,4.3,0,2.73,2.22,4.95,4.95,4.95s4.94-2.22,4.94-4.95c0-1.78-.96-3.43-2.51-4.3-.24-.14-.55-.05-.68.19s-.05.55.19.68c1.23.7,2,2.02,2,3.43,0,2.18-1.77,3.95-3.94,3.95s-3.95-1.77-3.95-3.95c0-1.42.77-2.73,2-3.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.83,11.18v-2.71c0-.28-.22-.5-.5-.5s-.5.22-.5.5v2.71c0,.28.22.5.5.5s.5-.22.5-.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.78,1.95c-2.36,0-4.28,1.92-4.28,4.28s1.92,4.28,4.28,4.28,4.28-1.92,4.28-4.28-1.92-4.28-4.28-4.28ZM17.78,9.5c-1.81,0-3.28-1.47-3.28-3.28s1.47-3.28,3.28-3.28,3.28,1.47,3.28,3.28-1.47,3.28-3.28,3.28Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.19,4.04h-.82c-.11,0-.2.1-.2.15l.41,2.88c.04.28.35.28.38.06l.41-2.88c.02-.11-.07-.22-.19-.22Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 17.78,
    cy: 8.01,
    r: 0.39
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.27,11.47c-.27.06-.44.32-.39.59.11.52.17,1.07.17,1.61,0,4.26-3.47,7.73-7.73,7.73s-7.73-3.47-7.73-7.73,3.47-7.73,7.73-7.73c.53,0,1.06.05,1.57.16.27.06.54-.12.59-.39.06-.27-.12-.53-.39-.59-.58-.12-1.18-.18-1.77-.18C5.52,4.94,1.6,8.86,1.6,13.67s3.92,8.73,8.73,8.73,8.73-3.92,8.73-8.73c0-.61-.06-1.22-.19-1.82-.06-.27-.32-.44-.59-.39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnoff);
export default __webpack_public_path__ + "static/media/onoff.ccc34a315463509d75e1e482260a7d95.svg";
export { ForwardRef as ReactComponent };